import React from "react";
import { createPortal } from "react-dom";
import iconsList from "../icons/iconsList";
import Icon from "../icons/Icon";
import classes from './Popup.module.css'

const Popup = ({ style, dropClass, dropClassClose, close, children, dropClassContainer, accessibilityDescription }) => {

    const handleClose = (e) => {
        e && e.stopPropagation()
        close && close()
    }

    return createPortal(
        // <AccessibilityPopup accessibilityDescription={accessibilityDescription} close={handleClose}>
        <div className={`${classes.BackdropPopupContainer} ${dropClassContainer}`} close={handleClose}>
            <div className={`${classes.BackdropPopup} ${dropClass}`} style={style}>
                {close && <Icon size="40px" name={iconsList.close} color={"black"} className={`${classes.Close} ${dropClassClose}`} onClick={handleClose} />}
                {children}
            </div>
        </div>,
        //  </AccessibilityPopup>,
        document.body
    )
}
export default Popup;